import { render, staticRenderFns } from "./scoreRules.vue?vue&type=template&id=d97abeea&scoped=true"
import script from "./scoreRules.vue?vue&type=script&lang=js"
export * from "./scoreRules.vue?vue&type=script&lang=js"
import style0 from "./scoreRules.vue?vue&type=style&index=0&id=d97abeea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97abeea",
  null
  
)

export default component.exports